import { PageTemplate } from "@omni/types/enums/pageTemplate.enum";
import { isEqual } from "lodash-es";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import { configureSearch } from "@/redux/modules/value/search/search.actions";
import {
    getSearchConfiguration,
    hasComponentResults
} from "@/redux/modules/value/search/search.selectors";
import { useAlgoliaParameters } from "@/utils/hooks/algolia/useAlgoliaParameters.hook";
import { isPageTemplate } from "@/utils/pageTemplate.utils";
import { configurationFromUrl } from "@/utils/search/routing/configurationFromUrl";
import {
    configurationToUrl,
    updateWindowTitleByConfiguration
} from "@/utils/search/routing/configurationToUrl";
import { SearchComponents } from "@/utils/search/types/searchComponent";

const useSearchRouting = (ignoreQuery: boolean) => {
    const dispatch = useThunkDispatch();
    const configuration = useSelector(getSearchConfiguration, isEqual);
    const results = useSelector(hasComponentResults);
    const algoliaParameters = useAlgoliaParameters();

    const isSearchPageTemplate = isPageTemplate(PageTemplate.Search);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const handleNavigate = () =>
            dispatch(
                configureSearch(configurationFromUrl(ignoreQuery), {
                    configuration: [],
                    state: SearchComponents.ALL
                })
            );

        handleNavigate();
        window.addEventListener("popstate", handleNavigate);
        return () => {
            window.removeEventListener("popstate", handleNavigate);
        };
    }, [algoliaParameters]);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (!configuration) return;
        if (!results) return;

        const url = configurationToUrl(configuration, ignoreQuery);
        if (isSearchPageTemplate) {
            updateWindowTitleByConfiguration(configuration);
        }

        if (url === location.href) return;

        history.pushState({}, "", url);
    }, [configuration]);
};

export { useSearchRouting };
